import { Header } from 'antd/lib/layout/layout';
import useTranslate from '@core/hooks/useTranslate';
import PageTop from '@root/modules/Sellers/Dashboard/components/PageTop';
import { useParams } from 'react-router-dom';
import ProductService from '../services/product';
import { Card, Typography, Input } from 'antd';
import moment from 'moment';
import { useEffect, useState } from 'react';
import DetailsPro from '@root/modules/Warehouse/Inquiry/components/details-pro';
import InfoProduct from '../components/InfoProduct';
import BreadcrumbList from '../../Stock/components/Breadcrumb';
import { formatDateTime } from '@root/utils/helpers/formatDate';
import ReceivingDetails from '../components/ReceivingDetails';

const Breadcrumb = [
  {
    tittle: '상품 관리',
    url: '/admin/seller/product'
  },
  {
    tittle: '상품 조회',
    url: '/admin/seller/product'
  },
  {
    tittle: '상품 상세',
    url: ''
  }
];
const { Text } = Typography;

const ProductDetailPage = () => {
  const [product, setProduct] = useState({} as any);
  const [info, setInfo] = useState<{
    tittle: string;
    completedDate: string | Date;
    quantity: number;
  }>({ tittle: '입고 완료일', completedDate: '22/09/2022', quantity: 0 });

  const [t] = useTranslate();

  const { productId }: any = useParams();

  const getDetail = async () => {
    const detailProduct = await ProductService.getDetailProduct(productId);
    detailProduct.data.updated_at = formatDateTime(
      detailProduct.data.updated_at
    );
    //  moment(detailProduct.data.updated_at)
    //   .utc(true ?? 9)
    //   .format('YYYY-MM-DD hh:mm:ss A');
    setProduct(detailProduct.data);
    setInfo({
      tittle: '입고 완료일',
      completedDate: detailProduct.data?.updated_at,
      quantity: detailProduct.data?.inventory?.deliveredQuantity ?? 0
    });
  };
  useEffect(() => {
    getDetail();
  }, []);

  return (
    <>
      <BreadcrumbList listBreadcrumb={Breadcrumb} />
      <div className="admin-container">
        <Card
          bordered={false}
          className="admin-card"
          style={{
            background: 'none'
          }}
        >
          <div className="header-detail">
            <div className="detail --center">
              <p className="title-info">물류센터</p>
              <Input
                style={{
                  display: 'inline-block',
                  minWidth: '12rem',
                  borderRadius: '0.3rem'
                }}
                value={product?.quotation?.warehouse?.name ?? ''}
              />
            </div>
            <div className="detail">
              <p className="title-info">물류센터 주소</p>
              <Input
                style={{
                  display: 'inline-block',
                  minWidth: '26rem',
                  borderRadius: '0.3rem'
                }}
                value={product?.quotation?.warehouse?.googleMapAddress ?? ''}
              />
            </div>
          </div>
          <div
            className=""
            style={{
              backgroundColor: 'white',
              padding: '30px 10px',
              borderRadius: '6px'
            }}
          >
            <div style={{ marginBottom: '0.5rem', padding: '0rem 1rem' }}>
              <InfoProduct info={info} />
            </div>
            {!!product.productName && (
              <DetailsPro
                img={product?.image?.url}
                productName={product.productName}
                width={product.width}
                height={product.height}
                length={product.length}
                demensionUnit={product.demensionUnit}
                weight={product.weight}
                weightUnit={product.weightUnit}
                estimateQuantity={product.estimateQuantity}
                averageMonthSale={product.averageMonthSale}
                sku={product.sku}
                eanUpc={product.eanUpc}
                asin={product.asin}
                packedMethod={product.packedMethod}
                storageMethod={product.storageMethod}
                dangerousGoods={product.dangerousGoods === true ? 'Yes' : 'No'}
                lotProduct={
                  product.lotProduct.charAt(0).toUpperCase() +
                  product.lotProduct.slice(1)
                }
              />
            )}
          </div>
          
        </Card>
        <Card bordered={false}
          className="admin-card"
          style={{
            background: 'none'
          }}>

            <ReceivingDetails productId={productId}/>

        </Card>
      </div>
    </>
  );
};

export default ProductDetailPage;
